import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Icon from "react-bootstrap-icons";

function Home(props) {
  const [login, setLogin] = useState(false);

  const checkToken = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      const { exp } = JSON.parse(jsonPayload);
      const expired = Date.now() >= exp * 1000;
      return expired;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    let username = localStorage.getItem("esri-tile-converter-username");
    let password = localStorage.getItem("esri-tile-converter-password");
    let token = localStorage.getItem("esri-tile-converter-token");
    if (username && password && token) setLogin(true);
    else setLogin(false);

    if (checkToken) {
      setLogin(true);
    } else {
      setLogin(false);
    }
  }, []);

  return (
    <div>
      {login && (
        <div className="App">
          <Row
            style={{
              minheight: "18rem",
              alignSelf: "center",
              alignItems: "flex-start",
            }}
          >
            <Col>
              <Card
                style={{ width: "18rem" }}
                onClick={() =>
                  window.open(
                    "https://portfolio.techmaven.net/apps/offline-map-data-generator/",
                    "",
                    ""
                  )
                }
              >
                <Card.Header>Offline Maps Data Generator</Card.Header>
                <Card.Body>
                  <Icon.ArrowRight />
                  <Card.Text>
                    Download geospatial data from different local and global web
                    mapping geospatial services.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card
                style={{ width: "18rem" }}
                onClick={() =>
                  window.open(
                    "https://portfolio.techmaven.net/dataservices/georequest-area-of-interest-api/",
                    "",
                    ""
                  )
                }
              >
                <Card.Header>Geo Request Data Conversion</Card.Header>
                <Card.Body>
                  <Icon.ArrowRight />
                  <Card.Text>
                    clip and download geonames data see more.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card
                style={{ width: "18rem" }}
                onClick={() =>
                  window.open(
                    "https://techmaven.net/portabletileserver/windows-tile-server/",
                    "",
                    ""
                  )
                }
              >
                <Card.Header>Tile Server</Card.Header>
                <Card.Body>
                  <Icon.ArrowRight />
                  <Card.Text>
                    serve mbtiles and other geospatial files.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}
export default Home;
